import { useState, useEffect } from 'react';

const useIsCustomScrollbar = () => {
  const [isCustomScrollbar, setIsCustomScrollbar] = useState(false);

  useEffect(() => {
    setIsCustomScrollbar(
      document.body.classList.contains('comet-custom-scrollbar')
    );
  }, []);

  return isCustomScrollbar;
};

export default useIsCustomScrollbar;
